"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerErrorMain = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var HeaderOneText_1 = require("../../text/HeaderOneText");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../../../styles/appStylesBase");
var SignOutButton_1 = require("../../../com/button/SignOutButton");
var AppLink_1 = require("../../link/AppLink/AppLink");
var appStyleClasses_1 = require("../../../styles/appStyleClasses");
var react_redux_1 = require("react-redux");
var useUpdateUnscopeUser_1 = require("../../../hooks/useUpdateUnscopeUser");
var firestore_1 = require("firebase/firestore");
var descriptionHelper_1 = require("../../../utilities/descriptionHelper");
var sentrySdk_1 = require("../../../sdks/sentry/sentrySdk");
var description = 'ServerErrorMain';
var ServerErrorMain = function (_a) {
    var onClick = _a.onClick, homePathname = _a.homePathname;
    var isLoggedId = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.cookieStorage) === null || _a === void 0 ? void 0 : _a.signedIntoDashboard;
    });
    var currentUserId = (0, react_redux_1.useSelector)(function (state) {
        return state.currentUserId;
    });
    var _b = (0, useUpdateUnscopeUser_1.useUpdateUnscopeUser)({
        parentDescription: description,
    }), updateUnscopeUser = _b.updateUnscopeUser, updateUnscopeUserReady = _b.updateUnscopeUserReady;
    (0, react_1.useEffect)(function () {
        (0, sentrySdk_1.sentrySdk)().captureException("ServerErrorMain - currentUserId: ".concat(currentUserId));
    }, [currentUserId]);
    (0, react_1.useEffect)(function () {
        if (updateUnscopeUserReady) {
            updateUnscopeUser({
                unscopeUser: {
                    wentWrongErrorCount: (0, firestore_1.increment)(1),
                },
            });
        }
    }, [updateUnscopeUserReady]);
    return (react_1.default.createElement("div", { className: "".concat((0, descriptionHelper_1.descriptionHelper)(description), " ").concat((0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        text-align: center;\n      "], ["\n        text-align: center;\n      "])))) },
        react_1.default.createElement(HeaderOneText_1.HeaderOneText, { styles: (0, emotion_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n          padding-top: ", ";\n          line-height: ", ";\n        "], ["\n          padding-top: ", ";\n          line-height: ", ";\n        "])), (0, appStylesBase_1.appStylesBase)().spacing.big, (0, appStylesBase_1.appStylesBase)().lineHeight.small) }, "Oops! Something went wrong. Try reloading or check back later."),
        react_1.default.createElement("ul", { className: (0, emotion_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n          > * {\n            display: inline-block;\n            margin: ", ";\n          }\n        "], ["\n          > * {\n            display: inline-block;\n            margin: ", ";\n          }\n        "])), (0, appStylesBase_1.appStylesBase)().spacing.small) },
            react_1.default.createElement("li", null,
                react_1.default.createElement("button", { type: "button", className: appStyleClasses_1.appStyleClasses.actionButtonStyles(), title: "Reload", onClick: function () {
                        window.location.reload();
                        onClick === null || onClick === void 0 ? void 0 : onClick();
                    } }, "Reload")),
            isLoggedId && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("li", null,
                    react_1.default.createElement(AppLink_1.AppLink, { title: "Go Home", className: "".concat(appStyleClasses_1.appStyleClasses.actionButtonStyles()), to: homePathname, onClick: onClick }, "Go Home")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement(SignOutButton_1.SignOutButton, { onClick: onClick, styles: "".concat(appStyleClasses_1.appStyleClasses.actionButtonStyles()) })))))));
};
exports.ServerErrorMain = ServerErrorMain;
var templateObject_1, templateObject_2, templateObject_3;
